export default __webpack_public_path__ + "static/media/token_bridge.22b5b493.png";